import * as React from "react";
const SvgUpload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <path
      fill="#6366F1"
      fillRule="evenodd"
      d="M4.167 25c0-9.82 0-14.73 3.05-17.783 3.054-3.05 7.963-3.05 17.783-3.05s14.732 0 17.782 3.05c3.052 3.054 3.052 7.963 3.052 17.783s0 14.732-3.052 17.782c-3.048 3.052-7.96 3.052-17.782 3.052-9.82 0-14.73 0-17.783-3.052-3.05-3.048-3.05-7.96-3.05-17.782M25 36.98a1.56 1.56 0 0 0 1.563-1.563V24.605l3.583 3.583a1.562 1.562 0 1 0 2.209-2.208l-6.25-6.25a1.563 1.563 0 0 0-2.209 0l-6.25 6.25a1.56 1.56 0 0 0 .48 2.591 1.56 1.56 0 0 0 1.729-.383l3.583-3.583v10.812c0 .862.7 1.563 1.562 1.563m-8.333-20.834a1.563 1.563 0 0 1 0-3.125h16.667a1.562 1.562 0 1 1 0 3.125z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUpload;